




























































import Debug from "@/components/utility/Debug.vue";
import PaginatedTable from "@/components/utility/v2/PaginatedTable.vue";
import { InvoiceStatusEnum } from "@/lib/enum/invoice-status.enum";
import { InvoiceGoToHelper } from "@/lib/utility/invoice.go-to-helper";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { handleError } from "@/lib/utility/handleError";
import { $t } from "@/lib/utility/t";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { Group } from "@/models/group.entity";
import { IInvoice } from "@/models/invoice.entity";
import { IPageFilterElement, PageFilterElement } from "@/models/page-filter-element.entity";
import { BackendResourceEnum } from "@/store/enum/authResourceEnum";
import { GroupModule } from "@/store/modules/group.store";
import { InvoiceOutboundModule } from "@/store/modules/invoice-outbound.store";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";
import ConfirmActionDialog from "../utility/ConfirmActionDialog.vue";
import RefsInvoice from "../utility/RefsInvoice.vue";
import RefsGroup from "../utility/RefsGroup.vue";
import { IControlElements, ITableWrapperHeader } from "../utility/TableWrapper.vue";
import CreateInvoiceOutboundDialog from "./CreateInvoiceOutboundDialog.vue";
import InvoiceSideCard from "./InvoiceSideCard.vue";
import DueDateChip from "@/components/project/DueDateChip.vue";
import { toArray } from "@/lib/array-helper";
import { formatCurrency } from "@/lib/utility/currency-helper";
import { simpleDate } from "@/lib/utility/date-helper";

@Component({
  components: {
    PaginatedTable,
    ConfirmActionDialog,
    CreateInvoiceOutboundDialog,
    InvoiceSideCard,
    RefsGroup,
    RefsInvoice,
    DueDateChip,
    Debug
  },
  filters: { simpleDate }
})
export default class InvoiceOutboundTable extends mixins(PermissionMixin) {
  readonly formatCurrency = formatCurrency;

  readonly toArray = toArray;

  readonly InvoiceStatusEnum = InvoiceStatusEnum;

  readonly BackendResourceEnum = BackendResourceEnum;

  readonly store = InvoiceOutboundModule;

  @Prop()
  partnerId!: string;

  @Prop()
  vehicleId?: string;

  @Prop()
  fleetId?: string;

  @Prop()
  reportId?: string;

  @Prop({ default: () => [] })
  filters!: IPageFilterElement[];

  @Prop()
  controlElements?: IControlElements[] | undefined;

  selectedItem: IInvoice | null = null;

  selectedItemForDelete: IInvoice | null = null;

  isDeleteDialogActive = false;

  isDeleteLoading = false;

  get headers(): ITableWrapperHeader[] {
    const headers: ITableWrapperHeader[] = [];

    headers.push({
      text: $t("objects.invoice.date"),
      value: "date",
      width: "150px"
    });

    headers.push({
      text: $t("objects.invoice.status"),
      value: "status",
      width: "100px"
    });

    headers.push({
      text: $t("objects.invoice.due"),
      value: "due",
      width: "150px"
    });

    headers.push({
      text: $t("objects.invoice.subTotal"),
      value: "subTotal",
      width: "200px",
      align: "end"
    });

    headers.push({
      text: $t("objects.invoice.buyer"),
      value: "buyer.name",
      width: "300px"
    });

    headers.push({
      text: $t("common.nouns.number"),
      value: "number",
      width: "100px"
    });

    headers.push({
      text: $t("objects.invoice.type"),
      value: "type",
      width: "100px"
    });

    headers.push({
      text: $t("objects.timestamp.created"),
      value: "timestamp.createdReadable",
      width: "120px",
      align: "end"
    });

    headers.push({ text: "", align: "end", value: "controls", width: 120, sortable: false });

    return headers;
  }

  get _controlElements(): IControlElements[] {
    if (this.controlElements) {
      return this.controlElements;
    }

    const controlElements: IControlElements[] = [
      {
        icon: "mdi-open-in-new",
        text: $t("report.ThgChargingStationDetailCard.toDetail"),
        action: (selectedItem: IInvoice) =>
          new InvoiceGoToHelper(this.$router).goToInvoiceDetail({
            invoiceId: selectedItem.id,
            partnerId: selectedItem.partnerId,
            newTab: true
          })
      }
    ];

    if (this.can(this.ActionEnum.DELETE, this.ResourceEnum.INVOICE)) {
      controlElements.push({
        icon: "mdi-trash-can",
        text: $t("delete"),
        action: this.onDeleteItem,
        disabled: (item: IInvoice) => !item.isUpdateable
      });
    }

    return controlElements;
  }

  get predefinedFilter(): { title: string; filter: IPageFilterElement[] }[] {
    const predefinedFilter: { title: string; filter: IPageFilterElement[] }[] = [];

    return predefinedFilter;
  }

  beforeMount() {
    const filters = [];

    if (this.reportId) {
      filters.push(new PageFilterElement({ key: "reportId", operation: "$eq", value: this.reportId }));
    }

    this.store.setFilters([...filters, ...this.filters]);
  }

  async getGroup(id: string) {
    if (!id) return;
    let group = GroupModule.maps.id.get(id)[0];
    if (!group) {
      group = new Group({ partnerId: this.partnerId, id });
      group.fetch();
    }

    return group;
  }

  simpleDoubleDigitDate(date: string) {
    return simpleDoubleDigitDate(date);
  }

  setSelectedItem(item: IInvoice | null) {
    this.selectedItem = null;

    this.$nextTick(() => {
      this.selectedItem = item;
      this.$emit("openSideCard", item);
    });
  }

  async onDeleteItem(item: IInvoice) {
    this.selectedItemForDelete = item;
    this.isDeleteDialogActive = true;
  }

  async onDelete() {
    this.isDeleteLoading = true;

    await this.selectedItemForDelete
      ?.delete()
      .then(() => {
        this.isDeleteLoading = false;
        this.isDeleteDialogActive = false;
        this.$toast.success("👍");
      })
      .catch(handleError);
  }
}
